module.exports = __webpack_public_path__ + "img/tema-1-12.e7c4e6e3.svg";